<template>
  <div class="mc-load-detail-request">
    <h4 class="mc-load-detail-request__title card-title">{{ $t('delivery.load') }}</h4>

    <McTable
      withCard
      searchable
      foot-clone
      hasEmit:deleteError
      :fields="fields"
      :apiClient="apiClient"
      :hasCheckbox="false"
      :hasSelectAll="false"
    >
      <template #cell(total_weight)="{ value }"> {{ value | formatNumber }} Kg </template>

      <template #cell(total_volume)="{ value }"> {{ value | formatNumber }} Cbm </template>

      <template #cell(note)="{ value }">
        {{ value || '-' }}
      </template>

      <template #foot()="{ column }">
        <div v-if="column === 'product.name'">{{ $t('deliveryRequest.table.total') }}</div>
        <div v-else-if="column === 'total_weight'">{{ totalLoadWeight | formatNumber }} Kg</div>
        <div v-else-if="column === 'total_volume'">{{ totalLoadVolume | formatNumber }} Cbm</div>
        <div v-else></div>
      </template>
    </McTable>
  </div>
</template>

<script>
import McTable from '@/components/McTable'
import * as Request from '@/services/rest-api/lib/request/request'
import { loadFields } from '../lib/fields/load-fields'

export default {
  components: {
    McTable,
  },
  inject: ['totalLoadWeight', 'totalLoadVolume'],
  computed: {
    fields() {
      return loadFields(this.$t.bind(this))
    },
    apiClient() {
      return {
        get: Request.getLoad(this.$route.params.id),
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.mc-load-detail-request {
  &__title {
    margin-bottom: 12px;
  }
}
</style>
